<template>
  <section class="admin-page">
    <div class="page-title">
      <h2>Stranice</h2>
      <div>
        <router-link :to="{ name: 'AddPage' }">
          <el-button type="primary" icon="el-icon-document-add">Dodaj novu stranu</el-button>
        </router-link>
      </div>
    </div>

    <el-table :data="data" style="width: 100%" empty-text="Ni jedna stranica nije pronadjena.">
      <el-table-column fixed label="Naziv">
        <template slot-scope="scope">
          {{ scope.row.data.rs.title }}
        </template>
      </el-table-column>
      <el-table-column
        prop="url"
        label="URL">
      </el-table-column>
      <el-table-column
        prop="urlEN"
        label="URL EN">
      </el-table-column>
      <el-table-column
        label="Akcije"
        width="120"
        align="right"
        right>
        <template slot-scope="scope">
          <router-link :to="{ name: 'EditPage', params: { id: scope.row.id } }">
            <el-button type="primary" size="small" icon="el-icon-edit" circle />
          </router-link>
          <el-button v-if="scope.row.deletable" type="danger" size="small" icon="el-icon-delete" circle @click="remove(scope.row.id)" />
        </template>
      </el-table-column>
    </el-table>
  </section>
</template>

<script>
import axios from 'axios'
import { Button, Table, TableColumn, Message, MessageBox } from 'element-ui'

export default {
  async beforeRouteEnter (to, from, next) {
    try {
      const { data } = await axios.get('/pages')
      next(vm => {
        vm.data = data.data
      })
    } catch {}
  },

  components: {
    ElTable: Table,
    ElButton: Button,
    ElTableColumn: TableColumn
  },

  data () {
    return {
      data: []
    }
  },

  methods: {
    async remove (id) {
      try {
        await MessageBox.confirm('Da li si siguran da želiš da obrišeš ovu stranu?', 'Upozorenje!', {
          confirmButtonText: 'Obriši',
          cancelButtonText: 'Odustani',
          type: 'error'
        })
        await axios.delete(`/page/${id}`)
        const idx = this.data.findIndex(page => page.id === id)
        this.data.splice(idx, 1)
        Message.success('Stranica uspešno obrisana.')
      } catch {}
    }
  }
}
</script>
